import { Header } from './Header/Header';
import { Wrapper } from './Wrapper/Wrapper';

export const UiAccountsList = {
  Wrapper,
  Header,
};
